module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "width": "24",
      "height": "24",
      "src": require("./loading.gif")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27e21343"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/loading/loading.vue
// module id = 565
// module chunks = 1